<button class="action" [disabled]="readonly" (click)="onSave()" [ngClass]="{'saving':saving}">
    <i *ngIf="showIcon" class="fa fa-lg fa-floppy-o icon" aria-hidden="true"></i>
    <ng-content *ngIf="!saving"></ng-content>
</button>